import React from "react";
import { Menu, MenuItem, ListItemIcon } from "@mui/material";

export interface ContextMenuAction {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  color?: string;
  show?: boolean; // conditional rendering wrapper
}

interface TableRowContextMenuProps<T> {
  contextMenu: { mouseX: number; mouseY: number; data: T } | null;
  onClose: () => void;
  actions: ContextMenuAction[];
}

export function TableRowContextMenu<T>({
  contextMenu,
  onClose,
  actions,
}: TableRowContextMenuProps<T>) {
  if (!contextMenu) return null;

  return (
    <Menu
      open={true}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={{ top: contextMenu.mouseY, left: contextMenu.mouseX }}
      componentsProps={{
        root: {
          onContextMenu: (e) => {
            e.preventDefault();
            onClose();
          },
        },
      }}
    >
      {actions
        .filter((a) => a.show !== false)
        .map((action, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              action.onClick();
              onClose();
            }}
            disabled={action.disabled}
            sx={{ color: action.color || "inherit" }}
          >
            <ListItemIcon sx={{ color: action.color || "inherit" }}>
              {action.icon}
            </ListItemIcon>
            {action.label}
          </MenuItem>
        ))}
    </Menu>
  );
}

export default TableRowContextMenu;
